import { render, staticRenderFns } from "./gymRatingGraphicAvgStudentBsquat.vue?vue&type=template&id=2d13913f&"
import script from "./gymRatingGraphicAvgStudentBsquat.js?vue&type=script&lang=js&"
export * from "./gymRatingGraphicAvgStudentBsquat.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports